import React from 'react';

const JewellerCard = ({ jeweller, onClick }) => {
  const initials = jeweller.companyName
    .split(' ')
    .map((word) => word[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <article
      role="button"
      tabIndex={0}
      onClick={() => onClick(jeweller)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick(jeweller);
        }
      }}
      style={{
        background: 'var(--Surface-Primary)',
        border: 'var(--card-border)',
        borderRadius: 'var(--radius-xl)',
        overflow: 'hidden',
        boxShadow: 'var(--shadow-card)',
        cursor: 'pointer',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        minHeight: '100%'
      }}
      onMouseEnter={(event) => {
        event.currentTarget.style.transform = 'translateY(-3px)';
        event.currentTarget.style.boxShadow = 'var(--shadow-frame-big)';
      }}
      onMouseLeave={(event) => {
        event.currentTarget.style.transform = 'translateY(0)';
        event.currentTarget.style.boxShadow = 'var(--shadow-card)';
      }}
    >
      <div
        style={{
          height: '220px',
          background: 'var(--Grey-100)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {jeweller.profilePhoto ? (
          <img
            src={jeweller.profilePhoto}
            alt={jeweller.companyName}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: 'block'
            }}
          />
        ) : (
          <div
            style={{
              width: '72px',
              height: '72px',
              borderRadius: '50%',
              background: 'var(--Surface-Primary)',
              border: '1px solid var(--Stroke-Light)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'var(--Text-Primary)',
              fontSize: 'var(--font-size-subtitle1)',
              fontWeight: 'var(--font-weight-subtitle1)'
            }}
          >
            {initials || 'JB'}
          </div>
        )}
      </div>

      <div
        style={{
          padding: 'var(--spacing-l)',
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--spacing-xs)'
        }}
      >
        <h3
          style={{
            margin: 0,
            color: 'var(--Text-Primary)',
            fontSize: 'var(--font-size-body2)',
            fontWeight: 'var(--font-weight-semibold)'
          }}
        >
          {jeweller.companyName}
        </h3>
        <p
          style={{
            margin: 0,
            color: 'var(--Text-Secondary)',
            fontSize: 'var(--font-size-body4)',
            fontWeight: 'var(--font-weight-medium)'
          }}
        >
          {jeweller.fullName}
        </p>
        {jeweller.location && (
          <p
            style={{
              margin: 0,
              color: 'var(--Text-Tertiary)',
              fontSize: 'var(--font-size-body5)'
            }}
          >
            {jeweller.location}
          </p>
        )}
        <p
          style={{
            margin: 'var(--spacing-xs) 0 0 0',
            color: 'var(--Text-Secondary)',
            fontSize: 'var(--font-size-body4)',
            lineHeight: '1.6',
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          }}
        >
          {jeweller.summary}
        </p>
      </div>
    </article>
  );
};

export default JewellerCard;
